import { useApiPrivateRequest } from "@/shared/hooks/useApi";

export const useEnableMcpTool = () => {
  const {
    data: isEnabled,
    call,
    isLoading: isEnabling,
    isFailed: isEnableFailed,
  } = useApiPrivateRequest<boolean>((_) => true);

  const enableMcpTool = async (toolName: string) => {
    await call(`/llm/mcpTools/${toolName}/enable`, "PUT");
  };

  return { isEnabled, enableMcpTool, isEnabling, isEnableFailed };
};
